import React from 'react';

const MarkerFilled = ({ ...props }) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M20.386 11.348c0-1.15-.432-2.142-1.294-2.974-.862-.831-1.898-1.247-3.109-1.247h-.045c-1.21 0-2.239.416-3.087 1.248-.847.832-1.27 1.838-1.27 3.018 0 1.18.43 2.179 1.292 2.996.863.817 1.9 1.226 3.11 1.226 1.211 0 2.247-.416 3.11-1.248.861-.832 1.293-1.824 1.293-2.974v-.045zm6.785 4.606a11.195 11.195 0 01-1.747 3.473l-8.67 12.164a1.076 1.076 0 01-.34.295.96.96 0 01-.476.114 1 1 0 01-.454-.114 1.01 1.01 0 01-.364-.295L6.361 19.472A10.907 10.907 0 014.591 16 13.212 13.212 0 014 12.12c0-1.604.28-3.178.838-4.72a10.268 10.268 0 012.61-3.995A11.114 11.114 0 0111.376.84 12.587 12.587 0 0115.892 0c1.483 0 2.958.281 4.426.84a11.728 11.728 0 013.925 2.474 10.818 10.818 0 012.633 4.062c.575 1.56.863 3.14.863 4.743 0 1.302-.189 2.58-.568 3.836z"
      ></path>
    </svg>
  );
};

export default MarkerFilled;
